<template>
  <div>
    <transition name="router-fade" mode="out-in">
        <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  mounted(){
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        window.addEventListener('hashchange', () => {
            let currentPath = window.location.hash.slice(1)
            if (this.$route.path !== currentPath) {
                this.$router.push(currentPath);// 主动更改路由界面
            }
        }, false);
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style/common';
  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }
</style>
